import { injectable, Inject } from 'inversify-props';
import HttpClient from './http-client';


@injectable()
export class BookingService {
    @Inject() httpClient: HttpClient;
    constructor() {
    }

    public getCityList(body: any) {
        return this.httpClient.post('/autocomplete/city', body);
    }
    public getCountryList(body: any) {
        return this.httpClient.post('/autocomplete/country', body);
    }
    public getStateList(body: any) {
        return this.httpClient.post('/autocomplete/state', body);
    }
    public book(body: any) {
        return this.httpClient.post('/book/book_fares', body);
    }

}
